var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { Box, FormControl, FormControlLabel, FormLabel, MenuItem, Radio, RadioGroup, Stack, TextField, } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { ContainerForm } from "../../components/ContainerForm";
import { FormButton, FormButtonType } from "../../components/FormButton";
import AppBarHeader from "../../components/Home/AppBarHeader";
import { Loading } from "../../components/Loading";
import { SnackbarFeedback } from "../../components/SnackbarFeedback";
import { useAuth } from "../../hooks/useAuth";
import { obterCidades } from "../../services/generico.service";
import { alterarEndereco, obterDadosCondutor, } from "../../services/habilitacao.service";
import { formatarCpf } from "../../util/mascaras";
import { alterarEnderecoSchema } from "../../validators/habilitacaoSchema";
import { Modal } from "../../components/Modal";
export var AlterarEndereco = function (_a) {
    var isInPage = _a.isInPage, isModal = _a.isModal, setInputAlterado = _a.setInputAlterado, isPid = _a.isPid;
    var userInfo = useAuth().userInfo;
    var navigate = useNavigate();
    var _b = useState(), dados = _b[0], setDados = _b[1];
    var _c = useState(), erro = _c[0], setErro = _c[1];
    var _d = useState(false), sucesso = _d[0], setSucesso = _d[1];
    var _e = useState(true), loading = _e[0], setLoading = _e[1];
    var _f = useState(""), cpf = _f[0], setCpf = _f[1];
    var _g = useState(), cep = _g[0], setCep = _g[1];
    var _h = useState(null), dataNascimento = _h[0], setDataNascimento = _h[1];
    var _j = useState(null), cidades = _j[0], setCidades = _j[1];
    var _k = useState(), isAddressChange = _k[0], setIsAddressChange = _k[1];
    var _l = useState(false), modal = _l[0], setModal = _l[1];
    var alterarEnderecoForm = useForm({
        resolver: zodResolver(alterarEnderecoSchema),
        defaultValues: {
            bairro: "",
            cep: "",
            codLocal: 0,
            complemento: "",
            cpf: "",
            dataNascimento: "",
            logradouro: "",
            numero: "",
            numeroRegistro: "",
            tipoLogradouro: "",
        },
    });
    var register = alterarEnderecoForm.register, handleSubmit = alterarEnderecoForm.handleSubmit, errors = alterarEnderecoForm.formState.errors, control = alterarEnderecoForm.control;
    var formatIsoParaData = function (input) {
        var date = new Date(input);
        var year = date.getUTCFullYear();
        var month = String(date.getUTCMonth() + 1).padStart(2, "0");
        var day = String(date.getUTCDate()).padStart(2, "0");
        return "".concat(year).concat(month).concat(day);
    };
    var handleRegistrarSolicitacao = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setErro(undefined);
                    setLoading(true);
                    payload = {
                        cpf: data.cpf,
                        bairro: data.bairro,
                        cep: Number(cep),
                        codLocal: data.codLocal,
                        complemento: data.complemento,
                        dataNascimento: formatIsoParaData(dataNascimento),
                        logradouro: data.logradouro,
                        numero: data.numero,
                        numeroRegistro: data.numeroRegistro,
                        tipoLogradouro: data.tipoLogradouro,
                    };
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, alterarEndereco(payload)];
                case 2:
                    _d.sent();
                    setSucesso(true);
                    setTimeout(function () {
                        navigate(0);
                    }, 500);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _d.sent();
                    setErro((_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao alterar dados de endereço");
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var encontrarCidadeChave = function () {
        var cidade = cidades === null || cidades === void 0 ? void 0 : cidades.find(function (cidade) { return cidade.idCidadePais === (dados === null || dados === void 0 ? void 0 : dados.idCidadePaisEndereco); });
        return cidade === null || cidade === void 0 ? void 0 : cidade.codLocal;
    };
    useEffect(function () {
        if (isAddressChange === 1) {
            setModal(true);
        }
    }, [isAddressChange]);
    useEffect(function () {
        var fetchDados = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_2;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, 3, 4]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        };
                        return [4 /*yield*/, obterDadosCondutor(payload)];
                    case 1:
                        response = _d.sent();
                        alterarEnderecoForm.reset({
                            cpf: response.cpf,
                            numeroRegistro: response.numeroRegistro,
                            dataNascimento: response.dataNascimento,
                            bairro: response.bairro,
                            cep: response.cep,
                            complemento: response.complemento,
                            logradouro: response.logradouro,
                            numero: response.numero,
                            tipoLogradouro: response.tipoLogradouro,
                        });
                        setDados(response);
                        setCpf(response.cpf);
                        setDataNascimento(moment(response.dataNascimento));
                        (response === null || response === void 0 ? void 0 : response.cep) && setCep(response.cep);
                        fetchCidades();
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _d.sent();
                        setErro((_c = (_b = (_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao recuperar dados do condutor");
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var fetchCidades = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_3;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(dados === null || dados === void 0 ? void 0 : dados.ufEmissao)) return [3 /*break*/, 4];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, obterCidades(dados === null || dados === void 0 ? void 0 : dados.ufEmissao)];
                    case 2:
                        response = _d.sent();
                        setCidades(response);
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _d.sent();
                        setErro((_c = (_b = (_a = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao listar cidades");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchDados();
    }, [alterarEnderecoForm, dados === null || dados === void 0 ? void 0 : dados.ufEmissao, userInfo]);
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(AppBarHeader, { titulo: "Segunda Via da CNH", voltarPara: "/home" }), _jsx(Loading, {})] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(FormProvider, __assign({}, alterarEnderecoForm, { children: _jsx("form", __assign({ onSubmit: handleSubmit(handleRegistrarSolicitacao) }, { children: _jsxs(Box, __assign({ mt: isInPage ? "-10rem" : "0" }, { children: [_jsxs(ContainerForm, __assign({ title: "Dados de Endere\u00E7o" }, { children: [(isInPage || isModal) && (_jsxs(_Fragment, { children: [_jsx(TextField, __assign({ id: "cpf", label: "CPF", variant: "outlined", value: formatarCpf(cpf), InputLabelProps: {
                                                    shrink: true,
                                                }, inputProps: {
                                                    maxLength: 11,
                                                } }, register("cpf", {
                                                onChange: function (e) { return setCpf(formatarCpf(e.target.value)); },
                                            }), { error: errors.cpf !== undefined, helperText: errors.cpf && errors.cpf.message, disabled: true })), _jsxs(Stack, __assign({ direction: "row", gap: "0.5rem" }, { children: [_jsx(LocalizationProvider, __assign({ dateAdapter: AdapterMoment }, { children: _jsx(DatePicker, { label: "Data de Nascimento", format: "DD/MM/YYYY", value: dataNascimento, onChange: function (newValue) { return setDataNascimento(newValue); }, sx: { flex: 1 }, disabled: true }) })), _jsx(TextField, __assign({ id: "numeroRegistro", label: "N\u00FAmero do Registro", variant: "outlined", InputLabelProps: {
                                                            shrink: true,
                                                        } }, register("numeroRegistro"), { error: errors.numeroRegistro !== undefined, helperText: errors.numeroRegistro && errors.numeroRegistro.message, sx: { flex: 1 }, disabled: true }))] }))] })), _jsxs(Stack, __assign({ direction: "row", gap: "0.5rem" }, { children: [_jsx(TextField, __assign({ id: "tipoLogradouro", label: "Tipo de Logradouro", variant: "outlined", InputLabelProps: {
                                                    shrink: true,
                                                } }, register("tipoLogradouro"), { error: errors.tipoLogradouro !== undefined, helperText: errors.tipoLogradouro && errors.tipoLogradouro.message, sx: { flexGrow: 1 }, disabled: !isInPage && !isModal })), _jsx(TextField, __assign({ id: "logradouro", label: "Logradouro", variant: "outlined", InputLabelProps: {
                                                    shrink: true,
                                                } }, register("logradouro"), { error: errors.logradouro !== undefined, helperText: errors.logradouro && errors.logradouro.message, sx: { flexGrow: 1 }, disabled: !isInPage && !isModal }))] })), _jsxs(Stack, __assign({ direction: "row", gap: "0.5rem" }, { children: [_jsx(TextField, __assign({ id: "numero", label: "N\u00FAmero", variant: "outlined", InputLabelProps: {
                                                    shrink: true,
                                                } }, register("numero"), { error: errors.numero !== undefined, helperText: errors.numero && errors.numero.message, sx: { flexGrow: 1 }, disabled: !isInPage && !isModal })), _jsx(TextField, __assign({ id: "complemento", label: "Complemento", variant: "outlined", InputLabelProps: {
                                                    shrink: true,
                                                } }, register("complemento"), { error: errors.complemento !== undefined, helperText: errors.complemento && errors.complemento.message, sx: { flexGrow: 1 }, disabled: !isInPage && !isModal }))] })), _jsxs(Stack, __assign({ direction: "row", gap: "0.5rem" }, { children: [_jsx(TextField, __assign({ id: "bairro", label: "Bairro", variant: "outlined", InputLabelProps: {
                                                    shrink: true,
                                                } }, register("bairro"), { error: errors.bairro !== undefined, helperText: errors.bairro && errors.bairro.message, sx: { flexGrow: 1 }, disabled: !isInPage && !isModal })), _jsx(TextField, __assign({ id: "cep", label: "CEP", variant: "outlined", InputLabelProps: {
                                                    shrink: true,
                                                }, inputProps: {
                                                    maxLength: 8,
                                                }, value: cep }, register("cep", {
                                                onChange: function (e) { return setCep(e.target.value.replace(/\D/g, "")); },
                                            }), { error: errors.cep !== undefined, helperText: errors.cep && errors.cep.message, sx: { flexGrow: 1 }, disabled: !isInPage && !isModal }))] })), cidades && dados && (_jsx(Controller, { name: "codLocal", control: control, defaultValue: Number(encontrarCidadeChave()), render: function (_a) {
                                            var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, ref = _b.ref;
                                            return (_jsx(TextField, __assign({ select: true, id: "codLocal", label: "Cidade", variant: "outlined", InputLabelProps: {
                                                    shrink: true,
                                                }, onChange: onChange, onBlur: onBlur, value: value, inputRef: ref, error: errors.codLocal !== undefined, helperText: errors.codLocal && errors.codLocal.message, disabled: !isInPage && !isModal }, { children: cidades.map(function (cidade) { return (_jsx(MenuItem, __assign({ value: Number(cidade.codLocal) }, { children: cidade.nomeLocal }), cidade.codLocal)); }) })));
                                        } })), !isInPage && !isModal && (_jsxs(FormControl, __assign({ disabled: isPid }, { children: [_jsx(FormLabel, __assign({ id: "demo-controlled-radio-buttons-group" }, { children: "Deseja alterar o endere\u00E7o?" })), _jsxs(RadioGroup, __assign({ "aria-labelledby": "demo-controlled-radio-buttons-group", name: "controlled-radio-buttons-group", value: !isPid ? isAddressChange : 0, onChange: function (e) {
                                                    setIsAddressChange(Number(e.target.value));
                                                    setInputAlterado(true);
                                                }, sx: { display: "flex", flexDirection: "row" } }, { children: [_jsx(FormControlLabel, { value: 0, control: _jsx(Radio, {}), label: "N\u00E3o" }), _jsx(FormControlLabel, { value: 1, control: _jsx(Radio, {}), label: "Sim" })] }))] })))] })), _jsx(Stack, __assign({ direction: { md: "row-reverse" }, sx: { gap: "1rem" } }, { children: (isInPage || isModal) && (_jsxs(_Fragment, { children: [_jsx(FormButton, { type: FormButtonType.PRIMARY, title: "Enviar", onClick: function () { return null; }, isSubmit: true }), !isModal && (_jsx(FormButton, { type: FormButtonType.SECONDARY, title: "Voltar", onClick: function () { return navigate("/home"); } }))] })) }))] })) })) })), _jsx(Modal, { open: modal, onClose: function () { return setModal(false); }, children: _jsx(AlterarEndereco, { isModal: true, setInputAlterado: function () { return null; } }), buttons: _jsx(FormButton, { title: "Fechar", type: FormButtonType.SECONDARY, onClick: function () { return setModal(false); } }) }), sucesso && (_jsx(SnackbarFeedback, { isOpen: true, type: "success", message: "Solicita\u00E7\u00E3o realizada com sucesso" })), erro && (_jsx(SnackbarFeedback, { isOpen: !!erro, message: erro, type: "error" }))] }));
};
